import { Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import { UnverifiedBadgeCounter } from "./UnverifiedBadgeCounter";

interface MissedBadgeCounterProps {
  unverifiedBadgeCount?: number;
  hasWorkedBadgeRequiredShift: boolean;
}

export function MissedBadgeCounter(props: MissedBadgeCounterProps) {
  const { unverifiedBadgeCount = 0, hasWorkedBadgeRequiredShift } = props;

  return (
    <Box>
      {unverifiedBadgeCount === 0 && hasWorkedBadgeRequiredShift && (
        <Box
          sx={(theme) => ({
            background: theme.palette.shift?.badgePolicy.successGradient,
            paddingY: theme.spacing(8),
            borderTopLeftRadius: theme.borderRadius?.medium,
            borderTopRightRadius: theme.borderRadius?.medium,
            display: "flex",
            justifyContent: "center",
            marginBottom: theme.spacing(-4),
            zIndex: 1,
            position: "relative",
          })}
        >
          <Text bold variant="body2">
            Thank you for being prepared!
          </Text>
        </Box>
      )}
      <Stack
        alignItems="center"
        spacing={6}
        sx={(theme) => ({
          backgroundColor: theme.palette.background.tertiary,
          padding: theme.spacing(5),
          zIndex: 10,
          position: "relative",
          borderRadius: theme.borderRadius?.medium,
          boxShadow: 2,
        })}
      >
        <Stack alignItems="center" spacing={1}>
          <Text variant="h1">{unverifiedBadgeCount}</Text>
        </Stack>

        <UnverifiedBadgeCounter unverifiedBadgeCount={unverifiedBadgeCount} />
      </Stack>
    </Box>
  );
}
